(() => {
  // app/scripts/common/define.js
  Object.assign(NodeList.prototype, {
    removeClass: function() {
      for (const item of this) {
        item.classList.remove(...arguments);
      }
    },
    toggleClass() {
      for (const item of this) {
        item.classList.toggle(...arguments);
      }
    },
    addClass: function() {
      for (const item of this) {
        item.classList.add(...arguments);
      }
    },
    addEvents: function() {
      for (const item of this) {
        item.addEvent(...arguments);
      }
    },
    removeEvents: function() {
      for (const item of this) {
        item.removeEvent(...arguments);
      }
    }
  });
  Object.assign(HTMLCollection.prototype, {
    removeClass: function() {
      for (const item of this) {
        item.classList.remove(...arguments);
      }
    },
    toggleClass() {
      for (const item of this) {
        item.classList.toggle(...arguments);
      }
    },
    addClass: function() {
      for (const item of this) {
        item.classList.add(...arguments);
      }
    },
    addEvents: function() {
      for (const item of this) {
        item.addEventListener(...arguments);
      }
    },
    removeEvents: function() {
      for (const item of this) {
        item.removeEventListener(...arguments);
      }
    },
    forEach: Array.prototype.forEach
  });
  Object.assign(HTMLElement.prototype, {
    removeClass: function() {
      this.classList.remove(...arguments);
    },
    addClass: function() {
      this.classList.add(...arguments);
    },
    toggleClass() {
      this.classList.toggle(...arguments);
    },
    hasClass: function() {
      return this.classList.contains(...arguments);
    }
  });
  Object.assign(Number.prototype, {
    toCurrency: moneyFormat
  });
  Object.assign(String.prototype, {
    toCurrency: moneyFormat
  });
  var moneyFormatString = theme.currency.moneyFormat;
  function moneyFormat(format, convertCents) {
    let cents = this;
    if (typeof Currencies !== "undefined" && theme.currency.isoCode !== Currencies.newCurrency && !format) {
      format = Currencies.newFormat;
      if (convertCents) {
        cents = Currencies.convert(cents, theme.currency.isoCode, Currencies.newCurrency);
      }
    }
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormatString;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  (function() {
    let nativeFetch = window.fetch;
    window.fetch = function(...agrs) {
      let dataType = !!agrs[1] ? agrs[1].dataType : "";
      return nativeFetch(...agrs).then((res) => {
        if (!res.ok || res.status == "404") {
          throw res.json();
        }
        switch (dataType) {
          case "json": {
            return res.json();
          }
          case "text": {
            return res.text();
          }
          default:
            return res;
        }
      });
    };
  })();

  // node_modules/intersection-observer/intersection-observer.js
  (function() {
    "use strict";
    if (typeof window !== "object") {
      return;
    }
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      if (!("isIntersecting" in window.IntersectionObserverEntry.prototype)) {
        Object.defineProperty(
          window.IntersectionObserverEntry.prototype,
          "isIntersecting",
          {
            get: function() {
              return this.intersectionRatio > 0;
            }
          }
        );
      }
      return;
    }
    function getFrameElement(doc) {
      try {
        return doc.defaultView && doc.defaultView.frameElement || null;
      } catch (e) {
        return null;
      }
    }
    var document2 = function(startDoc) {
      var doc = startDoc;
      var frame = getFrameElement(doc);
      while (frame) {
        doc = frame.ownerDocument;
        frame = getFrameElement(doc);
      }
      return doc;
    }(window.document);
    var registry = [];
    var crossOriginUpdater = null;
    var crossOriginRect = null;
    function IntersectionObserverEntry(entry) {
      this.time = entry.time;
      this.target = entry.target;
      this.rootBounds = ensureDOMRect(entry.rootBounds);
      this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
      this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
      this.isIntersecting = !!entry.intersectionRect;
      var targetRect = this.boundingClientRect;
      var targetArea = targetRect.width * targetRect.height;
      var intersectionRect = this.intersectionRect;
      var intersectionArea = intersectionRect.width * intersectionRect.height;
      if (targetArea) {
        this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
      } else {
        this.intersectionRatio = this.isIntersecting ? 1 : 0;
      }
    }
    function IntersectionObserver2(callback, opt_options) {
      var options = opt_options || {};
      if (typeof callback != "function") {
        throw new Error("callback must be a function");
      }
      if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) {
        throw new Error("root must be a Document or Element");
      }
      this._checkForIntersections = throttle(
        this._checkForIntersections.bind(this),
        this.THROTTLE_TIMEOUT
      );
      this._callback = callback;
      this._observationTargets = [];
      this._queuedEntries = [];
      this._rootMarginValues = this._parseRootMargin(options.rootMargin);
      this.thresholds = this._initThresholds(options.threshold);
      this.root = options.root || null;
      this.rootMargin = this._rootMarginValues.map(function(margin) {
        return margin.value + margin.unit;
      }).join(" ");
      this._monitoringDocuments = [];
      this._monitoringUnsubscribes = [];
    }
    IntersectionObserver2.prototype.THROTTLE_TIMEOUT = 100;
    IntersectionObserver2.prototype.POLL_INTERVAL = null;
    IntersectionObserver2.prototype.USE_MUTATION_OBSERVER = true;
    IntersectionObserver2._setupCrossOriginUpdater = function() {
      if (!crossOriginUpdater) {
        crossOriginUpdater = function(boundingClientRect, intersectionRect) {
          if (!boundingClientRect || !intersectionRect) {
            crossOriginRect = getEmptyRect();
          } else {
            crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
          }
          registry.forEach(function(observer) {
            observer._checkForIntersections();
          });
        };
      }
      return crossOriginUpdater;
    };
    IntersectionObserver2._resetCrossOriginUpdater = function() {
      crossOriginUpdater = null;
      crossOriginRect = null;
    };
    IntersectionObserver2.prototype.observe = function(target) {
      var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
        return item.element == target;
      });
      if (isTargetAlreadyObserved) {
        return;
      }
      if (!(target && target.nodeType == 1)) {
        throw new Error("target must be an Element");
      }
      this._registerInstance();
      this._observationTargets.push({ element: target, entry: null });
      this._monitorIntersections(target.ownerDocument);
      this._checkForIntersections();
    };
    IntersectionObserver2.prototype.unobserve = function(target) {
      this._observationTargets = this._observationTargets.filter(function(item) {
        return item.element != target;
      });
      this._unmonitorIntersections(target.ownerDocument);
      if (this._observationTargets.length == 0) {
        this._unregisterInstance();
      }
    };
    IntersectionObserver2.prototype.disconnect = function() {
      this._observationTargets = [];
      this._unmonitorAllIntersections();
      this._unregisterInstance();
    };
    IntersectionObserver2.prototype.takeRecords = function() {
      var records = this._queuedEntries.slice();
      this._queuedEntries = [];
      return records;
    };
    IntersectionObserver2.prototype._initThresholds = function(opt_threshold) {
      var threshold = opt_threshold || [0];
      if (!Array.isArray(threshold))
        threshold = [threshold];
      return threshold.sort().filter(function(t, i, a) {
        if (typeof t != "number" || isNaN(t) || t < 0 || t > 1) {
          throw new Error("threshold must be a number between 0 and 1 inclusively");
        }
        return t !== a[i - 1];
      });
    };
    IntersectionObserver2.prototype._parseRootMargin = function(opt_rootMargin) {
      var marginString = opt_rootMargin || "0px";
      var margins = marginString.split(/\s+/).map(function(margin) {
        var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
        if (!parts) {
          throw new Error("rootMargin must be specified in pixels or percent");
        }
        return { value: parseFloat(parts[1]), unit: parts[2] };
      });
      margins[1] = margins[1] || margins[0];
      margins[2] = margins[2] || margins[0];
      margins[3] = margins[3] || margins[1];
      return margins;
    };
    IntersectionObserver2.prototype._monitorIntersections = function(doc) {
      var win = doc.defaultView;
      if (!win) {
        return;
      }
      if (this._monitoringDocuments.indexOf(doc) != -1) {
        return;
      }
      var callback = this._checkForIntersections;
      var monitoringInterval = null;
      var domObserver = null;
      if (this.POLL_INTERVAL) {
        monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
      } else {
        addEvent(win, "resize", callback, true);
        addEvent(doc, "scroll", callback, true);
        if (this.USE_MUTATION_OBSERVER && "MutationObserver" in win) {
          domObserver = new win.MutationObserver(callback);
          domObserver.observe(doc, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
      this._monitoringDocuments.push(doc);
      this._monitoringUnsubscribes.push(function() {
        var win2 = doc.defaultView;
        if (win2) {
          if (monitoringInterval) {
            win2.clearInterval(monitoringInterval);
          }
          removeEvent(win2, "resize", callback, true);
        }
        removeEvent(doc, "scroll", callback, true);
        if (domObserver) {
          domObserver.disconnect();
        }
      });
      var rootDoc = this.root && (this.root.ownerDocument || this.root) || document2;
      if (doc != rootDoc) {
        var frame = getFrameElement(doc);
        if (frame) {
          this._monitorIntersections(frame.ownerDocument);
        }
      }
    };
    IntersectionObserver2.prototype._unmonitorIntersections = function(doc) {
      var index = this._monitoringDocuments.indexOf(doc);
      if (index == -1) {
        return;
      }
      var rootDoc = this.root && (this.root.ownerDocument || this.root) || document2;
      var hasDependentTargets = this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        if (itemDoc == doc) {
          return true;
        }
        while (itemDoc && itemDoc != rootDoc) {
          var frame2 = getFrameElement(itemDoc);
          itemDoc = frame2 && frame2.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
      if (hasDependentTargets) {
        return;
      }
      var unsubscribe = this._monitoringUnsubscribes[index];
      this._monitoringDocuments.splice(index, 1);
      this._monitoringUnsubscribes.splice(index, 1);
      unsubscribe();
      if (doc != rootDoc) {
        var frame = getFrameElement(doc);
        if (frame) {
          this._unmonitorIntersections(frame.ownerDocument);
        }
      }
    };
    IntersectionObserver2.prototype._unmonitorAllIntersections = function() {
      var unsubscribes = this._monitoringUnsubscribes.slice(0);
      this._monitoringDocuments.length = 0;
      this._monitoringUnsubscribes.length = 0;
      for (var i = 0; i < unsubscribes.length; i++) {
        unsubscribes[i]();
      }
    };
    IntersectionObserver2.prototype._checkForIntersections = function() {
      if (!this.root && crossOriginUpdater && !crossOriginRect) {
        return;
      }
      var rootIsInDom = this._rootIsInDom();
      var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
      this._observationTargets.forEach(function(item) {
        var target = item.element;
        var targetRect = getBoundingClientRect(target);
        var rootContainsTarget = this._rootContainsTarget(target);
        var oldEntry = item.entry;
        var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);
        var rootBounds = null;
        if (!this._rootContainsTarget(target)) {
          rootBounds = getEmptyRect();
        } else if (!crossOriginUpdater || this.root) {
          rootBounds = rootRect;
        }
        var newEntry = item.entry = new IntersectionObserverEntry({
          time: now(),
          target,
          boundingClientRect: targetRect,
          rootBounds,
          intersectionRect
        });
        if (!oldEntry) {
          this._queuedEntries.push(newEntry);
        } else if (rootIsInDom && rootContainsTarget) {
          if (this._hasCrossedThreshold(oldEntry, newEntry)) {
            this._queuedEntries.push(newEntry);
          }
        } else {
          if (oldEntry && oldEntry.isIntersecting) {
            this._queuedEntries.push(newEntry);
          }
        }
      }, this);
      if (this._queuedEntries.length) {
        this._callback(this.takeRecords(), this);
      }
    };
    IntersectionObserver2.prototype._computeTargetAndRootIntersection = function(target, targetRect, rootRect) {
      if (window.getComputedStyle(target).display == "none")
        return;
      var intersectionRect = targetRect;
      var parent = getParentNode(target);
      var atRoot = false;
      while (!atRoot && parent) {
        var parentRect = null;
        var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
        if (parentComputedStyle.display == "none")
          return null;
        if (parent == this.root || parent.nodeType == /* DOCUMENT */
        9) {
          atRoot = true;
          if (parent == this.root || parent == document2) {
            if (crossOriginUpdater && !this.root) {
              if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
                parent = null;
                parentRect = null;
                intersectionRect = null;
              } else {
                parentRect = crossOriginRect;
              }
            } else {
              parentRect = rootRect;
            }
          } else {
            var frame = getParentNode(parent);
            var frameRect = frame && getBoundingClientRect(frame);
            var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
            if (frameRect && frameIntersect) {
              parent = frame;
              parentRect = convertFromParentRect(frameRect, frameIntersect);
            } else {
              parent = null;
              intersectionRect = null;
            }
          }
        } else {
          var doc = parent.ownerDocument;
          if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != "visible") {
            parentRect = getBoundingClientRect(parent);
          }
        }
        if (parentRect) {
          intersectionRect = computeRectIntersection(parentRect, intersectionRect);
        }
        if (!intersectionRect)
          break;
        parent = parent && getParentNode(parent);
      }
      return intersectionRect;
    };
    IntersectionObserver2.prototype._getRootRect = function() {
      var rootRect;
      if (this.root && !isDoc(this.root)) {
        rootRect = getBoundingClientRect(this.root);
      } else {
        var doc = isDoc(this.root) ? this.root : document2;
        var html = doc.documentElement;
        var body = doc.body;
        rootRect = {
          top: 0,
          left: 0,
          right: html.clientWidth || body.clientWidth,
          width: html.clientWidth || body.clientWidth,
          bottom: html.clientHeight || body.clientHeight,
          height: html.clientHeight || body.clientHeight
        };
      }
      return this._expandRectByRootMargin(rootRect);
    };
    IntersectionObserver2.prototype._expandRectByRootMargin = function(rect) {
      var margins = this._rootMarginValues.map(function(margin, i) {
        return margin.unit == "px" ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
      });
      var newRect = {
        top: rect.top - margins[0],
        right: rect.right + margins[1],
        bottom: rect.bottom + margins[2],
        left: rect.left - margins[3]
      };
      newRect.width = newRect.right - newRect.left;
      newRect.height = newRect.bottom - newRect.top;
      return newRect;
    };
    IntersectionObserver2.prototype._hasCrossedThreshold = function(oldEntry, newEntry) {
      var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
      var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
      if (oldRatio === newRatio)
        return;
      for (var i = 0; i < this.thresholds.length; i++) {
        var threshold = this.thresholds[i];
        if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
          return true;
        }
      }
    };
    IntersectionObserver2.prototype._rootIsInDom = function() {
      return !this.root || containsDeep(document2, this.root);
    };
    IntersectionObserver2.prototype._rootContainsTarget = function(target) {
      var rootDoc = this.root && (this.root.ownerDocument || this.root) || document2;
      return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
    };
    IntersectionObserver2.prototype._registerInstance = function() {
      if (registry.indexOf(this) < 0) {
        registry.push(this);
      }
    };
    IntersectionObserver2.prototype._unregisterInstance = function() {
      var index = registry.indexOf(this);
      if (index != -1)
        registry.splice(index, 1);
    };
    function now() {
      return window.performance && performance.now && performance.now();
    }
    function throttle(fn, timeout) {
      var timer = null;
      return function() {
        if (!timer) {
          timer = setTimeout(function() {
            fn();
            timer = null;
          }, timeout);
        }
      };
    }
    function addEvent(node, event, fn, opt_useCapture) {
      if (typeof node.addEventListener == "function") {
        node.addEventListener(event, fn, opt_useCapture || false);
      } else if (typeof node.attachEvent == "function") {
        node.attachEvent("on" + event, fn);
      }
    }
    function removeEvent(node, event, fn, opt_useCapture) {
      if (typeof node.removeEventListener == "function") {
        node.removeEventListener(event, fn, opt_useCapture || false);
      } else if (typeof node.detachEvent == "function") {
        node.detachEvent("on" + event, fn);
      }
    }
    function computeRectIntersection(rect1, rect2) {
      var top = Math.max(rect1.top, rect2.top);
      var bottom = Math.min(rect1.bottom, rect2.bottom);
      var left = Math.max(rect1.left, rect2.left);
      var right = Math.min(rect1.right, rect2.right);
      var width = right - left;
      var height = bottom - top;
      return width >= 0 && height >= 0 && {
        top,
        bottom,
        left,
        right,
        width,
        height
      } || null;
    }
    function getBoundingClientRect(el) {
      var rect;
      try {
        rect = el.getBoundingClientRect();
      } catch (err) {
      }
      if (!rect)
        return getEmptyRect();
      if (!(rect.width && rect.height)) {
        rect = {
          top: rect.top,
          right: rect.right,
          bottom: rect.bottom,
          left: rect.left,
          width: rect.right - rect.left,
          height: rect.bottom - rect.top
        };
      }
      return rect;
    }
    function getEmptyRect() {
      return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 0,
        height: 0
      };
    }
    function ensureDOMRect(rect) {
      if (!rect || "x" in rect) {
        return rect;
      }
      return {
        top: rect.top,
        y: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        x: rect.left,
        right: rect.right,
        width: rect.width,
        height: rect.height
      };
    }
    function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
      var top = parentIntersectionRect.top - parentBoundingRect.top;
      var left = parentIntersectionRect.left - parentBoundingRect.left;
      return {
        top,
        left,
        height: parentIntersectionRect.height,
        width: parentIntersectionRect.width,
        bottom: top + parentIntersectionRect.height,
        right: left + parentIntersectionRect.width
      };
    }
    function containsDeep(parent, child) {
      var node = child;
      while (node) {
        if (node == parent)
          return true;
        node = getParentNode(node);
      }
      return false;
    }
    function getParentNode(node) {
      var parent = node.parentNode;
      if (node.nodeType == /* DOCUMENT */
      9 && node != document2) {
        return getFrameElement(node);
      }
      if (parent && parent.assignedSlot) {
        parent = parent.assignedSlot.parentNode;
      }
      if (parent && parent.nodeType == 11 && parent.host) {
        return parent.host;
      }
      return parent;
    }
    function isDoc(node) {
      return node && node.nodeType === 9;
    }
    window.IntersectionObserver = IntersectionObserver2;
    window.IntersectionObserverEntry = IntersectionObserverEntry;
  })();

  // node_modules/@shopify/theme-images/images.js
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }
    if (size === "master") {
      return removeProtocol(src);
    }
    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
      return removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
  }
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  // node_modules/@shopify/theme-sections/section.js
  var SECTION_ID_ATTR = "data-section-id";
  function Section(container, properties) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];
    Object.assign(this, validatePropertiesObject(properties));
    this.onLoad();
  }
  Section.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function extend(extension) {
      this.extensions.push(extension);
      var extensionClone = Object.assign({}, extension);
      delete extensionClone.init;
      Object.assign(this, extensionClone);
      if (typeof extension.init === "function") {
        extension.init.apply(this);
      }
    }
  };
  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError(
        "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
      );
    }
    if (container.getAttribute(SECTION_ID_ATTR) === null) {
      throw new Error(
        "Theme Sections: The section container provided does not have an id assigned to the " + SECTION_ID_ATTR + " attribute."
      );
    }
    return container;
  }
  function validatePropertiesObject(value) {
    if (typeof value !== "undefined" && typeof value !== "object" || value === null) {
      throw new TypeError(
        "Theme Sections: The properties object provided is not a valid"
      );
    }
    return value;
  }
  if (typeof Object.assign != "function") {
    Object.defineProperty(Object, "assign", {
      value: function assign(target) {
        "use strict";
        if (target == null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // node_modules/@shopify/theme-sections/theme-sections.js
  var SECTION_TYPE_ATTR = "data-section-type";
  var SECTION_ID_ATTR2 = "data-section-id";
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};
  var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  var instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  function register(type, properties) {
    if (typeof type !== "string") {
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    }
    if (typeof registered[type] !== "undefined") {
      throw new Error(
        'Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice'
      );
    }
    function TypedSection(container) {
      Section.call(this, container, properties);
    }
    TypedSection.constructor = Section;
    TypedSection.prototype = Object.create(Section.prototype);
    TypedSection.prototype.type = type;
    return registered[type] = TypedSection;
  }
  function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === "undefined") {
      containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
    }
    containers = normalizeContainers(containers);
    types.forEach(function(type) {
      var TypedSection = registered[type];
      if (typeof TypedSection === "undefined") {
        return;
      }
      containers = containers.filter(function(container) {
        if (isInstance(container)) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
          return true;
        }
        instances.push(new TypedSection(container));
        return false;
      });
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function(instance) {
      var index = instances.map(function(e) {
        return e.id;
      }).indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function(container) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function(instance) {
            return instance.container === container;
          })
        );
      });
    } else if (typeof selector === "string" || typeof firstElement === "string") {
      var types = normalizeType(selector);
      types.forEach(function(type) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function(instance) {
            return instance.type === type;
          })
        );
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id) {
    var instance;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    if (types === "*") {
      types = Object.keys(registered);
    } else if (typeof types === "string") {
      types = [types];
    } else if (types.constructor === Section) {
      types = [types.prototype.type];
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function(TypedSection) {
        return TypedSection.prototype.type;
      });
    }
    types = types.map(function(type) {
      return type.toLowerCase();
    });
    return types;
  }
  function normalizeContainers(containers) {
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
      containers = [];
    } else if (containers === null) {
      containers = [];
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }
    return containers;
  }
  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector(
        "[" + SECTION_ID_ATTR2 + '="' + id + '"]'
      );
      if (container !== null) {
        load(container.getAttribute(SECTION_TYPE_ATTR), container);
      }
    });
    document.addEventListener("shopify:section:unload", function(event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector(
        "[" + SECTION_ID_ATTR2 + '="' + id + '"]'
      );
      var instance = getInstances(container)[0];
      if (typeof instance === "object") {
        unload(container);
      }
    });
    document.addEventListener("shopify:section:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onSelect(event);
      }
    });
    document.addEventListener("shopify:section:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onDeselect(event);
      }
    });
    document.addEventListener("shopify:block:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockSelect(event);
      }
    });
    document.addEventListener("shopify:block:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockDeselect(event);
      }
    });
  }

  // app/scripts/common/function/debounce.js
  var debounce = (func, wait) => {
    let timeout;
    return function(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // app/scripts/common/function/backToTop.js
  var backToTop = function(button) {
    let target = button || document.getElementById("back-to-top");
    target.addEvent("click", () => {
      let position = window.pageYOffset;
      let minus = position * 10 / 100;
      requestAnimationFrame(step);
      function step() {
        if (position > 0) {
          position = position - minus;
          window.scrollTo(0, position);
          requestAnimationFrame(step);
        }
      }
    });
    if (window.pageYOffset > window.innerHeight * 1.5) {
      target.addClass("show");
    }
    window.addEvent("scroll", () => {
      if (window.pageYOffset > window.innerHeight * 1.5) {
        target.addClass("show");
      } else {
        target.hasClass("show") && target.removeClass("show");
      }
    });
  };

  // app/scripts/common/function/enableScroll.js
  function enableScroll() {
    document.documentElement.style.paddingRight = "";
    document.documentElement.removeClass("overflow-hidden");
  }

  // app/scripts/common/function/disableScroll.js
  function disableScroll() {
    let paddingRight = window.innerWidth - document.documentElement.offsetWidth + "px";
    document.documentElement.style.paddingRight = paddingRight;
    document.documentElement.addClass("overflow-hidden");
  }

  // app/scripts/common/function/loadCartNotify.js
  var loadCartNotify = () => {
    return new Promise((resolve, reject) => {
      AT.loadScript(theme.cartNotifyURL, () => {
        resolve(1);
      });
    });
  };

  // app/scripts/common/function/loadScript.js
  var loadScript = (url, cb) => {
    let script = document.createElement("script");
    script.src = url;
    !!cb && (script.onload = cb);
    document.body.append(script);
  };

  // app/scripts/common/function/inputQuantity.js
  var initInputQuantity = (container) => {
    let btnPlus = container.querySelector(".js-qty-plus");
    let btnMinus = container.querySelector(".js-qty-minus");
    let input = container.querySelector("input");
    let dataMax = +input.dataset.max;
    btnPlus.addEvent("click", () => {
      input.dispatchEvent(new CustomEvent("input", { detail: "plus" }));
    });
    btnMinus.addEvent("click", () => {
      input.dispatchEvent(new CustomEvent("input", { detail: "minus" }));
    });
    input.addEvent("input", function(e) {
      let { detail } = e;
      let min = !!this.min ? +this.min : void 0;
      let max = !!this.max ? +this.max : void 0;
      let value = +this.value;
      switch (detail) {
        case "plus":
          ++value;
          if (value > max) {
            this.value = max;
            e.reachedMaxNumber = true;
          } else if (value > dataMax) {
            this.value = dataMax;
            e.reachedLimit = true;
          } else {
            this.value = value;
          }
          break;
        case "minus":
          --value;
          this.value = min > value ? min : value;
          break;
      }
      return;
      if (!!min && value < min) {
        this.value = min;
      }
      if (!!max && value > max) {
        this.value = max;
      }
      if (!!dataMax && value > dataMax) {
        this.value = dataMax;
      }
      if (max === value) {
        e.reachedMaxNumber = true;
      } else {
        e.reachedMaxNumber = false;
      }
      if (dataMax == value) {
        e.reachedLimit = true;
      } else {
        e.reachedLimit = false;
      }
    });
  };

  // app/scripts/common/function/formAddToCart.js
  var initFormAddToCart = (form, cb) => {
    let btnAddToCart = form.querySelector(".btn-add-to-cart");
    let selectVariant = form.querySelector(".js-select-variant");
    let inputElemnets, resolve, reject;
    if (selectVariant) {
      inputElemnets = selectVariant.querySelectorAll("input");
      inputElemnets.addEvents("change", (e) => {
        e.stopPropagation();
        document.dispatchEvent(new CustomEvent("select-variant"));
      });
    }
    form.addEvent("submit", async (e) => {
      e.preventDefault();
      if (selectVariant) {
        let height = selectVariant.firstElementChild.offsetHeight;
        document.addEvent("click", function y(e2) {
          if (!form.contains(e2.target)) {
            document.dispatchEvent(new CustomEvent("not-select-variant"));
          }
          document.removeEvent("click", y);
        });
        selectVariant.addClass("is-open");
        selectVariant.style.height = height + "px";
        let promise = await new Promise((res, rej) => {
          [resolve, reject] = [res, rej];
          document.addEvent("select-variant", v);
          document.addEvent("not-select-variant", c);
          window.addEvent("resize", c);
        }).catch((error) => error);
        document.removeEvent("select-variant", v);
        document.removeEvent("not-select-variant", c);
        window.removeEvent("resize", c);
        selectVariant.removeClass("is-open");
        selectVariant.style.height = "";
        if (!promise) {
          return;
        }
      }
      btnAddToCart.addClass("pending");
      Cart.add(form).then(() => {
        btnAddToCart.removeClass("pending");
        inputElemnets && inputElemnets.forEach((input) => input.checked = false);
        typeof cb === "function" && cb();
      });
    });
    function v() {
      resolve(1);
    }
    function c() {
      reject(0);
    }
  };

  // app/scripts/common/function/cookie.js
  var cookie = {
    get: function(key) {
      var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
      return keyValue ? keyValue[2] : null;
    },
    set: function(key, value, expiry) {
      var expires = /* @__PURE__ */ new Date();
      expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1e3);
      document.cookie = key + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
    },
    delete: function(key) {
      var keyValue = this.get(key);
      this.set(key, keyValue, "-1");
    }
  };

  // app/scripts/common/function/loadCurrencies.js
  var loadCurrencies = () => {
    let template = document.getElementById("template-modal-currencies");
    let arrPromise = [];
    template.insertAdjacentElement("beforebegin", template.content.firstElementChild);
    template.remove();
    arrPromise.push(
      new Promise((resolve, reject) => {
        AT.loadScript("/services/javascripts/currencies.js", () => {
          resolve(1);
        });
      })
    );
    arrPromise.push(
      new Promise((resolve, reject) => {
        AT.loadScript(theme.currenciesURL, () => {
          resolve(1);
        });
      })
    );
    return Promise.all(arrPromise).then(() => {
      document.dispatchEvent(new CustomEvent("currencies-initialization"));
    });
  };

  // app/scripts/common/function/loadSearch.js
  var loadSearch = () => {
    let searchTemplate = document.getElementById("search-drawer-template");
    document.body.append(searchTemplate.content.firstElementChild);
    searchTemplate.remove();
    return new Promise((resolve, reject) => {
      AT.loadScript(theme.searchURL);
      document.addEvent("search-initialized", () => resolve(1));
    });
  };

  // app/scripts/common/function/initCollapse.js
  var initCollapse = (button, targetElement) => {
    button.addEvent("click", () => {
      let height = targetElement.firstElementChild.offsetHeight + "px";
      if (targetElement.hasClass("is-open")) {
        targetElement.style.height = height;
        targetElement.removeClass("is-open");
        AT.debounce(() => {
          targetElement.style.height = "";
        }, 1)();
      } else {
        targetElement.style.height = height;
        targetElement.addClass("is-open");
      }
    });
  };

  // app/scripts/common/function/convertToSlug.js
  var convertToSlug = (string) => {
    return string.toLowerCase().replace(/-/g, " ").trim().replace(/[\(\)\[\]'"]/g, "").replace(/[^\w]+/g, "-");
  };

  // app/scripts/common/function/linkOptions.js
  var linkOptions = (container, product, cb) => {
    let optionsMap = {};
    let optionElements = container.getElementsByClassName("js-option-item");
    if (product.variants.length <= 1) {
      return;
    }
    optionElements.addEvents("change", function() {
      container.dispatchEvent(new CustomEvent("variant-change", { detail: +this.dataset.position }));
    });
    container.addEvent("variant-change", function({ detail: position }) {
      switch (position) {
        case 1:
          if (product.options.length > 1) {
            updateOptionsInSelector(2);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 2:
          if (product.options.length === 3) {
            updateOptionsInSelector(3);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 3:
          cb(findVariantFromOption(getValueOptions()));
          break;
      }
    });
    product.variants.forEach((variant) => {
      if (variant.available) {
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = optionsMap["root"].reduce((accu, currentvalue) => {
          if (!accu.includes(currentvalue)) {
            accu.push(currentvalue);
          }
          return accu;
        }, []);
        if (product.options.length > 1) {
          var key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
        if (product.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
      }
    });
    updateOptionsInSelector(1);
    function updateOptionsInSelector(index) {
      let setValue = false;
      let optionValues = getValueOptions();
      let key, selector, old_value;
      switch (index) {
        case 1:
          key = "root";
          selector = container.querySelector(".swatch-select[data-option-position='1']");
          old_value = optionValues.option1;
          break;
        case 2:
          key = optionValues.option1;
          selector = container.querySelector(".swatch-select[data-option-position='2']");
          old_value = optionValues.option2;
          break;
        case 3:
          key = optionValues.option1 + " / " + optionValues.option2;
          selector = container.querySelector(".swatch-select[data-option-position='3']");
          old_value = optionValues.option3;
          break;
      }
      selector.getElementsByClassName("js-option-item").forEach((option) => {
        let { value } = option;
        if (optionsMap[key].includes(value)) {
          option.disabled = false;
          option.closest(".input-group").removeClass("d-none");
        } else {
          option.closest(".input-group").addClass("d-none");
          option.disabled = true;
          old_value === value && (setValue = true);
        }
      });
      if (setValue) {
        [...selector.getElementsByClassName("js-option-item")].find(
          (option) => !option.disabled && (option.checked = true)
        );
      }
      container.dispatchEvent(new CustomEvent("variant-change", { detail: index }));
    }
    function getValueOptions() {
      return [...new FormData(container).entries()].reduce((accu, currentValue) => {
        if (["option1", "option2", "option3"].includes(currentValue[0])) {
          accu[currentValue[0]] = currentValue[1];
        }
        return accu;
      }, {});
    }
    function findVariantFromOption(options) {
      return product.variants.find((variant) => {
        return Object.keys(options).every((optionKey) => variant[optionKey] === options[optionKey]);
      });
    }
  };

  // app/scripts/common/function/initEventCurrencies.js
  var initEventCurrencies = (() => {
    let modalTemplate = document.getElementById("template-modal-currencies");
    let modalContainer = modalTemplate.content.firstElementChild;
    let modalLoaded = false;
    return () => {
      document.addEvent("open-modal-currency", () => {
        if (modalLoaded) {
          modalContainer.addClass("is-open");
        } else {
          modalTemplate.insertAdjacentElement("beforebegin", modalContainer);
          modalTemplate.remove();
          modalLoaded = true;
          modalContainer.querySelectorAll(".js-close").addEvents("click", () => {
            modalContainer.removeClass("is-open");
          });
          AT.debounce(() => modalContainer.addClass("is-open"), 100)();
        }
        document.dispatchEvent(new CustomEvent("close-header-drawer"));
      });
    };
  })();

  // app/scripts/common/function/detectVisible.js
  var detectVisible = ({ element, rootMargin, callback, threshold = 0 }) => {
    let observer = new IntersectionObserver(
      (entries, observer2) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            callback();
            observer2.unobserve(element);
          }
        });
      },
      { rootMargin, threshold }
    );
    observer.observe(element);
  };

  // app/scripts/common/function/scrollTo.js
  function scrollTo(element, duration, minus = 0) {
    return new Promise((resolve, reject) => {
      var startingY = window.pageYOffset;
      var elementY = getElementY(element) - minus;
      var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
      var diff = targetY - startingY;
      var easing = function(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      };
      var start;
      if (!diff)
        return resolve(1);
      window.requestAnimationFrame(function step(timestamp) {
        if (!start)
          start = timestamp;
        var time = timestamp - start;
        var percent = Math.min(time / duration, 1);
        percent = easing(percent);
        window.scrollTo(0, startingY + diff * percent);
        if (time < duration) {
          window.requestAnimationFrame(step);
        } else {
          resolve(1);
        }
      });
    });
    function getElementY(query) {
      return typeof query == "number" ? query : window.pageYOffset + query.getBoundingClientRect().top;
    }
  }

  // app/scripts/common/model/cart.js
  var Cart2 = class {
    constructor() {
      this.elms = {
        headerIcons: document.getElementsByClassName("js-cart-icon"),
        cartItemCount: document.getElementsByClassName("js-cart-items-count")
      };
      this.cartValidation();
      this.get().then(() => {
        this.checkCustomer();
        this.checkBundleProducts();
      });
      this.settings = { ...theme.settings.cart };
      if (!theme.template.includes("cart")) {
        this.initDrawer();
      }
      this.initEventCartIcons();
    }
    cartValidation() {
      if (theme.customer.tags.some((tag) => tag.includes("wholesale"))) {
        fetch(`${theme.routes.searchURL}?view=check-cart`, { dataType: "json" }).then((res) => {
          if (Object.keys(res.updates).length) {
            SendMessage.open(theme.strings.cartValidation);
            this.changeMulti(res);
          }
        });
      }
    }
    checkCustomer() {
      this.checkIP();
      return;
    }
    addMutiple(items) {
      return fetch(theme.routes.cartAdd, {
        method: "post",
        headers: new Headers({ "Content-type": "application/json" }),
        body: JSON.stringify({ items: [...items] }),
        dataType: "json"
      }).then((data) => {
        return this.get().then(async (data2) => {
          if (this.settings.type === "drawer") {
            if (!this.drawer) {
              return data2;
            }
            if (this.drawer.isLoaded) {
              this.updateDrawer(data2);
            } else {
              await this.drawer.load();
            }
            return data2;
          }
        });
      }).catch((res) => {
        res.then((data) => {
          if (!!this.drawer && this.drawer.isOpen) {
            this.drawer.close();
            AT.debounce(() => SendMessage.open(data.description), 300)();
          } else {
            SendMessage.open(data.description);
          }
        });
        return res;
      });
    }
    async add(form) {
      let mainProductId = (form.querySelector("[name='id']").type == "select-one" ? form.querySelector("[name='id']") : form.querySelector("[name='id']").type == "hidden" ? form.querySelector("[name='id']") : form.querySelector("[name='id']:checked")).value;
      if (!await this.checkVariant(mainProductId, +form.quantity.value)) {
        return;
      }
      let inputUpsell = form.querySelector("input[name='upsell_variants']");
      let giftBoxElm = form.querySelector(".js-gift-box"), giftBoxItem;
      let bundleProductElements = form.querySelectorAll(".js-bundle-products_group:not(.d-none) .js-no-exist-bundle-items"), bundleProductItems;
      let upsellData;
      if (inputUpsell) {
        upsellData = inputUpsell.value;
      }
      let arrPromise = [];
      bundleProductElements.length && (bundleProductItems = [...bundleProductElements].reduce((acc, element) => {
        acc.push({
          id: +element.value,
          quantity: +element.dataset.quantity * +form.quantity.value,
          variantTitle: element.dataset.variantTitle
        });
        return acc;
      }, []));
      let items = [];
      if (bundleProductElements.length) {
        items.push(...bundleProductItems);
      } else {
        items.push(
          [...new FormData(form).entries()].reduce((accu, value) => {
            accu[value[0]] = value[1];
            return accu;
          }, {})
        );
      }
      giftBoxElm && (giftBoxItem = {
        id: +giftBoxElm.querySelector("input").value,
        quantity: 1,
        properties: items.reduce((acc, value) => (acc[value.variantTitle] = value.quantity.toString(), acc), {})
      });
      if (giftBoxElm && giftBoxElm.querySelector("input").checked) {
        items.push(giftBoxItem);
      }
      arrPromise.push(
        fetch(theme.routes.cartAdd, {
          method: "post",
          headers: new Headers({ "X-Requested-With": "XMLHttpRequest", "Content-type": "application/json" }),
          body: JSON.stringify({
            items,
            sections: "cart-line-items",
            sections_url: theme.routes.searchURL + "?view=line-items"
          }),
          dataType: "json"
        })
      );
      arrPromise.push(
        upsellData ? fetch(`${theme.routes.searchURL}?view=product-card-list&q=${upsellData}`, { dataType: "text" }) : ""
      );
      return Promise.all(arrPromise).then(async (data) => {
        let addedProducts = data[0];
        let upsellContent = data[1] || "";
        let addedMainProduct = addedProducts.items.find((item) => item.id == mainProductId);
        if (theme.template === "cart") {
          window.location.reload();
          return;
        }
        await this.get();
        console.log("bundleProductElements", bundleProductElements);
        if (bundleProductElements.length) {
          bundleProductItems.map((item) => {
            item.key = addedProducts.items.find((i) => i.id == item.id).key;
          });
          giftBoxElm.querySelector("input").checked && (giftBoxItem.key = addedProducts.items.find((i) => i.id == giftBoxItem.id).key);
          giftBoxItem.added = giftBoxElm.querySelector("input").checked;
          this.updateBundleProducts(bundleProductItems, giftBoxItem);
        }
        if (this.settings.type === "drawer" && !!this.drawer) {
          if (this.drawer.isLoaded) {
            this.updateDrawer(Object.assign({ ...this.value }, { sections: addedProducts.sections }));
          } else {
            this.drawer.load();
          }
        }
        if (addedMainProduct) {
          if (typeof this.notify === "undefined") {
            AT.loadCartNotify().then(() => {
              this.notify.show(addedMainProduct, upsellContent);
            });
          } else {
            if (this.notify.isOpen) {
              this.notify.close().then(() => this.notify.show(addedMainProduct, upsellContent));
            } else {
              this.notify.show(addedMainProduct, upsellContent);
            }
          }
        } else {
          SendMessage.open(theme.strings.addedItemsToCart);
        }
        return addedMainProduct;
      }).catch((res) => {
        console.log(res);
        res.then((data) => {
          if (!!this.drawer && this.drawer.isOpen) {
            this.drawer.close();
            AT.debounce(() => SendMessage.open(data.description), 300)();
            return;
          }
          SendMessage.open(data.description);
        });
      });
    }
    get() {
      return fetch(theme.routes.getCart, { dataType: "json" }).then((data) => {
        this.value = data;
        this.updateCartAttributeDiscountMessage(data);
        this.updateCartItemCountElement();
        return data;
      });
    }
    updateCartAttributeDiscountMessage({ items, attributes }) {
      let notes = [];
      let currentBundles = attributes["bundles"] ? attributes["bundles"].split(", ") : [];
      items.map((item) => {
        if (item.discounts.length) {
          item.discounts.map((discount) => {
            let discountTitle = discount.title.toLowerCase();
            if (discountTitle.indexOf("bundle") != -1 && !notes.includes(discount.title) && !currentBundles.includes(discount.title)) {
              notes.push(discount.title);
            }
          });
        }
      });
      if (notes.length) {
        let noteStr = notes.join(", ");
        fetch(theme.routes.cartUpdate, {
          method: "post",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            attributes: {
              bundles: noteStr
            }
          })
        });
      }
    }
    changeMulti(items) {
      return fetch(theme.routes.cartUpdate, {
        method: "post",
        body: JSON.stringify(items),
        headers: { "Content-type": "application/json" },
        dataType: "json"
      });
    }
    change(key, quantity, sections = "", sections_url = "") {
      let formData = new FormData();
      formData.append("id", key);
      formData.append("quantity", quantity);
      sections && formData.append("sections", sections);
      sections_url && formData.append("sections_url", sections_url);
      return fetch(theme.routes.cartChange, {
        method: "post",
        body: formData,
        headers: new Headers({ "X-Requested-With": "XMLHttpRequest" }),
        dataType: "json"
      }).then((data) => {
        this.value = data;
        this.updateCartItemCountElement();
        return data;
      });
    }
    update(variantID, quantity) {
      return fetch(theme.routes.cartUpdate, {
        method: "post",
        credentials: "same-origin",
        body: `updates[${variantID}]=${quantity}&sections=cart-line-items&sections_url=${theme.routes.searchURL}?view=line-items`,
        dataType: "json",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then((data) => (this.value = data, console.log(data), data)).catch((error) => console.log(error));
    }
    updateBundleProducts(bundleProductItems, giftBoxItem) {
      let bundleProducts = JSON.parse(window.localStorage.getItem("bundle-products-added") || "[]");
      window.localStorage.setItem(
        "bundle-products-added",
        JSON.stringify([
          ...bundleProducts,
          {
            items: bundleProductItems,
            giftBox: giftBoxItem
          }
        ])
      );
    }
    checkBundleProducts() {
      let bundleProducts = JSON.parse(window.localStorage.getItem("bundle-products-added") || "[]");
      if (this.value.item_count == 0) {
        window.localStorage.removeItem("bundle-products-added");
      } else {
        let splitedItems = this.value.items.reduce((acc, item) => {
          for (let index = 1; index <= item.quantity; index++) {
            acc.push({ key: item.key, quantity: 1 });
          }
          return acc;
        }, []);
        for (let index = 0; index < bundleProducts.length; index++) {
          let bundleItem = bundleProducts[index];
          if (bundleItem.items.reduce((acc, item) => (acc += item.quantity, acc), 0) > splitedItems.reduce((acc, item) => (acc += item.quantity, acc), 0)) {
            bundleProducts[index] = null;
          } else if (bundleItem.items.every((item) => {
            return item.quantity <= splitedItems.filter((i) => i.key == item.key).reduce((acc, i) => (acc += i.quantity, acc), 0);
          })) {
            bundleItem.items.forEach(({ key, quantity }) => {
              for (let index2 = 1; index2 <= quantity; index2++) {
                splitedItems.splice(
                  splitedItems.findIndex((i) => i.key == key),
                  1
                );
              }
            });
          } else {
            bundleProducts[index] = null;
          }
        }
        bundleProducts = bundleProducts.filter(Boolean);
        bundleProducts.length ? window.localStorage.setItem("bundle-products-added", JSON.stringify(bundleProducts)) : window.localStorage.removeItem("bundle-products-added");
      }
    }
    removeBundleProductsAttributes() {
      fetch(theme.routes.cartUpdate, {
        method: "post",
        headers: new Headers({ "Content-type": "application/json" }),
        dataType: "json",
        body: JSON.stringify({
          attributes: {
            "Bundle products added": ""
          }
        })
      });
    }
    remove(key, sections = "cart-line-items", sections_url = `${theme.routes.searchURL}?view=line-items`) {
      return fetch(theme.routes.cartChange, {
        method: "post",
        headers: new Headers({ "Content-Type": "application/json" }),
        dataType: "json",
        body: JSON.stringify({
          id: key,
          quantity: 0,
          sections,
          sections_url
        })
      }).then((data) => {
        this.value = data;
        this.updateCartItemCountElement();
        return data;
      });
    }
    initEventCartIcons() {
      let { headerIcons, cartItemCount } = this.elms;
      if (theme.settings.cart.type === "drawer" && theme.template !== "cart") {
        init.call(this);
        document.addEvent("init-mobile-header", init.bind(this), { once: true });
        document.addEvent("init-desk-header", init.bind(this), { once: true });
      }
      document.addEvent(
        "init-mobile-header",
        () => {
          [...cartItemCount].forEach((item) => {
            item.innerHTML = this.value.item_count;
            if (this.value.item_count >= 100) {
              item.addClass("small");
            } else {
              item.removeClass("small");
            }
          });
        },
        { once: true }
      );
      document.addEvent(
        "init-desk-header",
        () => {
          [...cartItemCount].forEach((item) => {
            item.innerHTML = this.value.item_count;
            if (this.value.item_count >= 100) {
              item.addClass("small");
            } else {
              item.removeClass("small");
            }
          });
        },
        { once: true }
      );
      function init() {
        headerIcons.forEach((element) => {
          if (!element.hasClass("initialized-event")) {
            element.addEvent("click", () => {
              if (this.drawer.isLoaded) {
                this.drawer.open();
              } else {
                this.drawer.open();
                this.drawer.load();
              }
            });
            element.addClass("initialized-event");
          }
        });
      }
    }
    initDrawer() {
      let cartDrawer = document.getElementById("cart_drawer");
      if (!cartDrawer) {
        return;
      }
      let buttonsCloseDrawer = cartDrawer.getElementsByClassName("js-drawer-close");
      let buttonOpenDrawer = document.getElementsByClassName("js-btn-open-cart-drawer");
      this.drawer = {
        pending: false,
        isOpen: false,
        open: function() {
          typeof Search !== "undefined" && Search.close();
          document.dispatchEvent(new CustomEvent("close-header-drawer"));
          cartDrawer.addClass("is-open");
          AT.disableScroll();
          this.isOpen = true;
        },
        close: function() {
          cartDrawer.removeClass("is-open");
          AT.debounce(AT.enableScroll, 300)();
          this.isOpen = false;
        },
        isLoaded: false,
        load: function(animation) {
          let drawerContainer = cartDrawer.querySelector(".js-drawer-container");
          return fetch(`${theme.routes.searchURL}/?view=cart-drawer${animation ? "&q=animation" : ""}`, {
            dataType: "text"
          }).then((text) => {
            drawerContainer.innerHTML = text;
            this.elms = {
              totalMoneyElm: drawerContainer.querySelector(".js-cart-total-money"),
              cartItemTemplate: drawerContainer.querySelector(".js-cart-item.template"),
              cartList: drawerContainer.querySelector(".js-cart-list"),
              drawerBodyContainer: drawerContainer.querySelector(".drawer_body"),
              upsellProductElements: drawerContainer.querySelectorAll(".cart-upsell_item")
            };
            initEventCloseDrawer.call(this, drawerContainer.getElementsByClassName("js-drawer-close"));
            this.initEventUpsellProduct();
            let lineItems = drawerContainer.querySelectorAll(".js-cart-item");
            lineItems.forEach(this.initEventLineItem);
            this.isLoaded = true;
            return text;
          });
        },
        initEventLineItem: (lineItemElement) => {
          let key = lineItemElement.dataset.key;
          let variantID = lineItemElement.dataset.variantId;
          let btnRemove = lineItemElement.querySelector(".js-btn-remove");
          let input = lineItemElement.querySelector("input.js-qty");
          let messageElement = lineItemElement.querySelector(".message");
          AT.initInputQuantity(lineItemElement.querySelector(".js-qty-container"));
          btnRemove.addEvent("click", () => {
            btnRemove.addClass("pending");
            this.remove(key).then((data) => {
              lineItemElement.remove();
              this.value = data;
              this.updateDrawer(data, "remove");
            });
          });
          let messageDebounce = AT.debounce(() => messageElement.addClass("d-none"), 2e3);
          input.addEvent(
            "input",
            AT.debounce((e) => {
              if (e.reachedLimit && input.dataset.itemAdded === input.value || e.reachedMaxNumber && input.dataset.itemAdded == input.value) {
                messageElement.removeClass("d-none");
                messageDebounce();
                return;
              }
              lineItemElement.style.pointerEvents = "none";
              this.update(variantID, e.target.value).then((data) => {
                lineItemElement.style.pointerEvents = "";
                this.updateDrawer(data);
              });
            }, 500)
          );
        },
        initQuantity(element) {
          let inputPlus = element.querySelector(".js-qty-plus");
          let input = element.querySelector("input");
          let inputMinus = element.querySelector(".js-qty-minus");
          let min = +input.dataset.min;
          let max = +input.dataset.max;
          input.addEvent("input", () => {
            let value = +input.value;
            if (max && value > max) {
              input.value = max;
              return;
            }
            if (min && value < 0 || value < min) {
              input.value = 0;
            } else {
              input.value = value;
            }
          });
          inputPlus.addEvent("click", () => {
            let value = +input.value;
            value++;
            if (value < min) {
              input.value = min;
              return;
            }
            input.value = max && value > max ? max : value;
          });
          inputMinus.addEvent("click", () => {
            let value = +input.value;
            value--;
            if (value < 0 || value < min) {
              input.value = 0;
            } else {
              input.value = value;
            }
          });
        },
        initEventUpsellProduct: () => {
          let { upsellProductElements } = this.drawer.elms;
          upsellProductElements.forEach((element) => {
            let form = element.querySelector("form.form-add-to-card");
            let atcButton = form.querySelector(".btn-add-to-cart");
            let variantContainer = form.querySelector(".js-upsell-variants");
            let variantElms = variantContainer.querySelectorAll("li");
            variantElms.addEvents("click", (e) => {
              let { variantId } = e.target.dataset;
              if (variantId) {
                form.id.value = variantId;
              }
            });
            form.addEvent("submit", async (e) => {
              e.preventDefault();
              let nextStep = await new Promise((res, rej) => {
                variantContainer.addClass("is-show");
                document.addEvent("click", checkClickOutside);
                function checkClickOutside(event) {
                  if (!variantContainer.contains(event.target)) {
                    variantContainer.removeClass("is-show");
                    document.removeEvent("click", checkClickOutside);
                    rej(0);
                  } else if ([...variantElms].some((elm) => elm == event.target)) {
                    res(1);
                    variantContainer.removeClass("is-show");
                    q;
                  }
                }
              });
              if (nextStep) {
                atcButton.addClass("pending");
                this.add(form).finally(() => {
                  atcButton.removeClass("pending");
                  this.drawer.close();
                });
              }
            });
          });
        }
      };
      document.addEvent("close-cart-drawer", () => {
        this.drawer.close();
      });
      document.addEvent("open-cart-drawer", () => {
        this.drawer.open();
        !this.drawer.isLoaded && this.drawer.load(true);
      });
      buttonOpenDrawer.addEvents("click", () => {
        this.drawer.open();
        !this.drawer.isLoaded && this.drawer.load(true);
      });
      initEventCloseDrawer.call(this.drawer, buttonsCloseDrawer);
      function initEventCloseDrawer(buttons) {
        buttons.addEvents("click", () => this.close());
      }
    }
    async updateDrawer(data, action) {
      let { totalMoneyElm, cartList, drawerBodyContainer } = this.drawer.elms;
      let { sections } = data;
      drawerBodyContainer.setAttribute("data-cart-items", data.item_count);
      totalMoneyElm.innerHTML = data.total_price.toCurrency();
      if (sections) {
        let div = document.createElement("div");
        div.innerHTML = sections["cart-line-items"];
        cartList.innerHTML = "";
        div.querySelectorAll(".js-cart-item").forEach((lineItemElm) => cartList.append(lineItemElm));
        cartList.children.forEach(this.drawer.initEventLineItem);
      }
    }
    clear(callback) {
      return fetch("/cart/clear.js", { method: "post", dataType: "json" }).then((data) => {
        this.value = data;
        console.log("cart clear!!!");
        if (callback)
          callback();
      });
    }
    checkVariant(variantId, quantity) {
      return fetch(`/variants/${variantId}?section_id=variant-info`, { dataType: "text" }).then((content) => {
        let div = document.createElement("div");
        div.innerHTML = content;
        let {
          metafields: { no_wholesale, maxqty }
        } = JSON.parse(div.firstElementChild.innerHTML);
        switch (typeof no_wholesale) {
          case "string":
            if (no_wholesale.toLocaleLowerCase() == "true") {
              SendMessage.open(theme.strings.noWholesale);
              return false;
            }
            break;
          case "boolean":
            if (no_wholesale) {
              SendMessage.open(theme.strings.noWholesale);
              return false;
            }
            break;
        }
        let variantFound = this.value.items.find(({ variant_id }) => variant_id == variantId);
        if ((variantFound ? variantFound.quantity : 0) + quantity > maxqty) {
          SendMessage.open(theme.strings.quantityLimit.replace("{{number}}", maxqty));
          return false;
        }
        return true;
      }).catch((error) => {
        return true;
      });
    }
    checkIP() {
      let currencyForm = document.getElementById("currency_form");
      let input = currencyForm.querySelector("input[name='currency']");
      let buttonSubmit = currencyForm.querySelector("button[type='submit']");
      currencyForm.addEvent("submit", function(e) {
        e.preventDefault();
        let formData = new FormData(this);
        console.log("formData: ", formData);
        fetch(theme.routes.cartUpdate, {
          method: "post",
          body: formData
        });
      });
      if (!!theme.customer.id && theme.customer.tags.some((tag) => tag.includes("wholesale"))) {
        fetch("/browsing_context_suggestions.json", {
          dataType: "json"
        }).then(({ detected_values }) => {
          submitForm(detected_values.country_name);
          AT.cookie.set("arn-customer-ip", JSON.stringify(detected_values), 30);
        });
      } else if (AT.cookie.get("arn-customer-ip")) {
        submitForm(JSON.parse(AT.cookie.get("arn-customer-ip")).country_name);
      } else {
        fetch("/browsing_context_suggestions.json", {
          dataType: "json"
        }).then(({ detected_values }) => {
          submitForm(detected_values.country_name);
          AT.cookie.set("arn-customer-ip", JSON.stringify(detected_values), 30);
        });
      }
      function submitForm(country) {
        if (country !== "Canada" && theme.currency.isoCode === "CAD") {
          input.value = "USD";
          theme.currency.isoCode = "USD";
          theme.customer.properties["Currency iso code"] = "USD";
          buttonSubmit.click();
        }
      }
    }
    updateCartItemCountElement() {
      [...this.elms.cartItemCount].forEach((item) => {
        item.innerHTML = this.value.item_count;
        if (this.value.item_count >= 100) {
          item.addClass("small");
        } else {
          item.removeClass("small");
        }
      });
    }
  };

  // app/scripts/common/model/productCard.js
  var ProductCard2 = class {
    constructor() {
      let productList = document.getElementsByClassName("js-product-card");
      productList.forEach((productElm) => {
        this.init(productElm);
      });
    }
    init(elm) {
      this.initAddToCart(elm).then(() => {
        if (elm.hasClass("js-product-card")) {
          !elm.hasClass("product-initialized") && elm.addClass("product-initialized");
        } else {
          !elm.querySelector(".js-product-card").hasClass("product-initialized") && elm.querySelector(".js-product-card").addClass("product-initialized");
        }
      }).catch((error) => {
        console.warn("Has an error on Product Card:", error);
        console.log(elm);
      });
    }
    initAddToCart(elm) {
      return new Promise((resolve, reject) => {
        let forms = elm.querySelectorAll("form[action='/cart/add']");
        if (!forms.length) {
          return;
        }
        try {
          forms.forEach(AT.initFormAddToCart);
          resolve(1);
        } catch (error) {
          reject(error);
        }
      });
    }
  };

  // app/scripts/common/model/sendMessage.js
  var SendMessage2 = class {
    constructor() {
      let container = this.container = document.getElementById("modal-message");
      this.elms = {
        messageElm: container.querySelector(".js-message")
      };
      container.querySelectorAll(".js-close").addEvents("click", () => this.close());
    }
    open(message) {
      this.elms.messageElm.innerHTML = message;
      this.container.addClass("is-open");
      AT.disableScroll();
    }
    close() {
      this.container.removeClass("is-open");
      AT.enableScroll();
    }
  };

  // app/scripts/common/section/header.js
  var Header = {
    onLoad: function() {
      let { container } = this;
      this.elms = {
        mainMegaMenuContainer: document.getElementById("main-mega-menu"),
        lazySublinkContainer: container.querySelector("#lazy-header-menu"),
        searchIcon: container.querySelector(".js-search-icon")
      };
      if (window.innerWidth > 992) {
        this.initDesktop();
        document.addEvent("init-mobile-header", () => {
          this.initMobile();
        });
      } else {
        this.initMobile();
        document.addEvent("init-desk-header", () => {
          this.initDesktop();
        });
      }
    },
    initMobile() {
      let { container } = this;
      let { mainMegaMenuContainer, lazySublinkContainer } = this.elms;
      let mobileMegaMenu = mainMegaMenuContainer.content.lastElementChild;
      let mobileSublinksMenu = lazySublinkContainer.content.lastElementChild;
      let headerMobileContainer = container.querySelector("#header-mobile-container");
      let drawerToggleButton = headerMobileContainer.querySelector(".js-header-hamburger");
      let drawerContainer = headerMobileContainer.querySelector("#mobile-menu-drawer");
      let searchIcon = headerMobileContainer.querySelector(".js-icon-search");
      this.initSearchIcon(searchIcon);
      drawerToggleButton.addEvent("click", function() {
        document.body.style.setProperty("--header-height", headerMobileContainer.offsetHeight + "px");
        if (this.hasClass("active")) {
          AT.enableScroll();
          drawerContainer.removeClass("is-open");
          this.removeClass("active");
        } else {
          this.addClass("active");
          AT.disableScroll();
          drawerContainer.addClass("is-open");
        }
      });
      [...drawerContainer.querySelectorAll(".js-lazy-menu")].forEach((nav) => {
        nav.querySelector(".js-toggle-menu").addEvent(
          "click",
          () => {
            let lazyMenuContainer = nav.querySelector(".js-lazy-dropdown");
            let { targetId, resource } = lazyMenuContainer.dataset;
            switch (resource) {
              case "mega-menu":
                lazyMenuContainer.innerHTML = mobileMegaMenu.querySelector(`[data-id="${targetId}"]`).innerHTML;
                console.log(mobileMegaMenu.querySelector(`[data-id="${targetId}"]`));
                break;
              case "sublinks":
                lazyMenuContainer.innerHTML = mobileSublinksMenu.querySelector(`[data-id="${targetId}"]`).innerHTML;
                break;
            }
            initEventButtonToogle(lazyMenuContainer);
          },
          { once: true }
        );
      });
      initEventButtonToogle(drawerContainer);
      function initEventButtonToogle(container2) {
        let openButtons = container2.querySelectorAll(".js-toggle-menu.js-open");
        let closeButtons = container2.querySelectorAll(".js-toggle-menu.js-close");
        openButtons.forEach((button) => {
          let target = drawerContainer.querySelector(`#${button.dataset.target}`);
          button.addEvent("click", function() {
            target.addClass("is-open");
          });
        });
        closeButtons.forEach((button) => {
          let target = drawerContainer.querySelector(`#${button.dataset.target}`);
          button.addEvent("click", function() {
            target.removeClass("is-open");
          });
        });
      }
      document.addEvent("close-header-drawer", () => {
        drawerContainer.removeClass("is-open");
        drawerToggleButton.removeClass("active");
      });
    },
    initDesktop() {
      let { container } = this;
      let headerDesktopContainer = container.querySelector("#header-desktop-container");
      let { mainMegaMenuContainer, lazySublinkContainer } = this.elms;
      let desktopMegaMenu = mainMegaMenuContainer.content.firstElementChild;
      let lazySublink = lazySublinkContainer.content.firstElementChild;
      let searchIcon = headerDesktopContainer.querySelector(".js-icon-search");
      let lazyNavElements = headerDesktopContainer.getElementsByClassName("js-lazy-menu");
      this.initSearchIcon(searchIcon);
      lazyNavElements.forEach((element) => {
        let dropdownElement = element.querySelector(".js-lazy-dropdown");
        let { targetId, resource } = dropdownElement.dataset;
        element.addEvent(
          "mouseover",
          () => {
            switch (resource) {
              case "mega-menu":
                dropdownElement.innerHTML = desktopMegaMenu.querySelector(`[data-id='${targetId}']`).innerHTML;
                break;
              case "sublinks":
                dropdownElement.innerHTML = lazySublink.querySelector(`[data-id='${targetId}']`).innerHTML;
                break;
            }
          },
          { once: true }
        );
      });
    },
    initSearchIcon(button) {
      button.addEvent("click", () => {
        if (typeof Search !== "undefined") {
          Search.open();
        } else {
          AT.loadSearch().then(() => Search.open());
        }
      });
    }
  };

  // app/scripts/common/section/newsletter.js
  var Newsletter = {
    onLoad: function() {
      let { container } = this;
      if (Shopify.designMode) {
        return;
      }
      try {
        if (!AT.cookie.get("arn-newsletter")) {
          AT.debounce(() => {
            let newsLetterContainer = container.content.firstElementChild;
            container.insertAdjacentElement("beforebegin", newsletterContainer);
            container.remove();
            let btnClose = newsLetterContainer.getElementsByClassName("js-modal-close");
            btnClose.addEvents("click", function() {
              newsLetterContainer.removeClass("is-open");
            });
            newsletterContainer.addClass("is-open");
            AT.cookie.set("arn-newsletter", true, 2);
          }, 2e3);
        }
      } catch (error) {
        console.warn("Section Newsletter has an error: ", error);
        console.log(container);
      }
    },
    onSelect: function() {
      this.container.addClass("is-open");
      let btnClose = this.container.getElementsByClassName("js-modal-close");
      btnClose.addEvents("click", () => {
        this.container.removeClass("is-open");
      });
    },
    onDeselect: function() {
      this.container.removeClass("is-open");
    }
  };

  // app/scripts/common.js
  (() => {
    window.AT = {
      debounce,
      backToTop,
      disableScroll,
      enableScroll,
      loadCartNotify,
      loadScript,
      getSizedImageUrl,
      initInputQuantity,
      initFormAddToCart,
      loadCurrencies,
      loadSearch,
      initCollapse,
      cookie,
      convertToSlug,
      linkOptions,
      detectVisible,
      scrollTo
    };
    register("header", Header);
    theme.sectionRegister?.includes("newsletter") && register("newsletter", Newsletter);
    load("*");
    window.register = register;
    window.load = load;
    window.Cart = new Cart2();
    window.SendMessage = new SendMessage2();
    window.ProductCard = new ProductCard2();
    if (window.theme.isWholesaleCustomer) {
      if (window.AT.cookie.get("WholesaleCustomerIsLogged") == "false") {
        window.AT.cookie.set("WholesaleCustomerIsLogged", true, 1);
        let callback = window.Cart.updateCartItemCountElement.bind(window.Cart);
        window.Cart.clear(callback);
      }
    } else {
      window.AT.cookie.set("WholesaleCustomerIsLogged", false, 1);
    }
    document.addEvent("lazyincluded", (e) => {
      let type = e.target.dataset.type;
      switch (type) {
        case "product-card": {
          window.ProductCard.init(e.target.querySelector(".js-product-card"));
          break;
        }
      }
    });
    window.AT.backToTop();
    initEventCurrencies();
    document.dispatchEvent(new CustomEvent("common.js loaded"));
    console.log("common.js loaded");
  })();
})();
